var lax = require('../../node_modules/lax.js/lib/lax.js');
'use strict';
var $ = require('jquery');


$(document).ready(function () {

	lax.init();

	// Add a driver that we use to control our animations
	lax.addDriver('scrollY', function () {
		return window.scrollY;
	});

	// Add animation bindings to elements
	lax.addElements('.lax--in', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY', 'elCenterY-150', 'elCenterY-75', 'elOutY'],
				{
					766: [0, 0, 0, 0, 0],
					767: [200, 80, 45, 0, -85],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			// opacity: [
			// 	['elInY', 'elCenterY-125'],
			// 	[0, 1],   // Animation value map
			// 	{
			// 		easing: 'easeOutExpo',
			// 	}
			// ],
		},
	},

	{
		onUpdate: function (driverValues, domElement) {
			var value = $(domElement).parents('.lax-sync-parent').find('.lax-sync-from').css('transform');
			// console.log(value);
			$(domElement).parents('.lax-sync-parent').find('.lax-sync-to').css('transform', value);
		}
	});

	lax.addElements('.lax--in-lp', {
		scrollY: {
			translateY: [
				// ['elInY', 'elCenterY', 'elCenterY-150', 'elCenterY-25', 'elOutY'],
				// {
				// 	1199: [0, 0, 0, 0, 0],
				// 	1200: [300, 15, -20, -35, -350],   // Animation value map
				// },
				// {
				// 	easing: 'easeOutExpo',
				// }
				['elInY', 'elCenterY', 'elOutY'],
				{
					1199: [0, 0, 0],
					1200: [300, 0, -300],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			// opacity: [
			// 	['elInY', 'elCenterY-125'],
			// 	[0, 1],   // Animation value map
			// 	{
			// 		easing: 'easeOutExpo',
			// 	}
			// ],
		},
	},

	{
		onUpdate: function (driverValues, domElement) {
			var value = $(domElement).parents('.lax-sync-parent').find('.lax-sync-from').css('transform');
			// console.log(value);
			$(domElement).parents('.lax-sync-parent').find('.lax-sync-to').css('transform', value);
		}
	});

	lax.addElements('.lax--early-in', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY-150', 'elCenterY-100', 'elCenterY-25', 'elOutY'],
				{
					766: [0, 0, 0, 0, 0],
					767: [150, 10, 0, -15, -100],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

	lax.addElements('.lax--slanted-in', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY-150', 'elCenterY-100', 'elCenterY-25', 'elOutY'],
				{
					766: [0, 0, 0, 0, 0],
					767: [150, 10, 0, -15, -100],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

	lax.addElements('.lax--slanted-out', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY-150', 'elCenterY-100', 'elCenterY-25', 'elOutY'],
				{
					766: [0, 0, 0, 0, 0],
					767: [-150, -10, 0, 15, 100],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

	lax.addElements('.lax--rotate', {
		scrollY: {
			rotate: [
				['elInY', 'elOutY'],
				{
					766: [0, 0],
					767: [-50, 40],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

	lax.addElements('.lax--pay-poster', {
		scrollY: {
			rotate: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-140, -2],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateX: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-650, -15],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateY: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-550, 0],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			scale: [
				['elInY', 'elCenterY-240'],
				{
					766: [1, 1],
					767: [0.6, 1],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],

		},
	});

	lax.addElements('.lax--iso-poster', {
		scrollY: {
			rotate: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [140, 3],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateX: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-250, 0],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateY: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [50, -35],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			scale: [
				['elInY', 'elCenterY-240'],
				{
					766: [1, 1],
					767: [0.6, 1],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],

		},
	});

	lax.addElements('.lax--ref-poster', {
		scrollY: {
			rotate: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-140, 0],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateX: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [550, 15],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			translateY: [
				['elInY', 'elCenterY-240'],
				{
					766: [0, 0],
					767: [-200, 0],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			scale: [
				['elInY', 'elCenterY-240'],
				{
					766: [1, 1],
					767: [0.6, 1],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],

		},
	});


	lax.addElements('.lax--partner-heading', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY', 'elOutY'],
				{
					1199: [0, 0, 0],
					1200: [300, 0, -100],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			scale: [
				['elInY', 'elCenterY'],
				{
					766: [1, 1],
					767: [1.5, 1],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

	lax.addElements('.lax--partner-subheading', {
		scrollY: {
			translateY: [
				['elInY', 'elCenterY-40', 'elOutY'],
				{
					1199: [0, 0, 0],
					1200: [350, -20, -150],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
			scale: [
				['elInY', 'elCenterY+40'],
				{
					766: [1, 1],
					767: [1.3, 1],   // Animation value map
				},
				{
					easing: 'easeOutExpo',
				}
			],
		},
	});

});
